var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 39.7",
    style: {
      enableBackground: "new 0 0 39.7 39.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000073707353930114016690000003563394681277550213_);fill:#54585A;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    width: 39.7,
    height: 39.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152972309704047942050000011825919843521188518_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000152972309704047942050000011825919843521188518_)",
      fill: "#54585A"
    },
    d: "M36.3,2.1l-1.8,1.8 l1.4,1.4l1.8-1.8L36.3,2.1z M32,3.8L5.5,30.3l4,4L36,7.8L32,3.8z M2.5,37.3L8,35.1l-3.4-3.3L2.5,37.3z M39.7,3.5 c0,0.2-0.1,0.4-0.2,0.6c0,0-0.1,0.1-0.1,0.1L37,6.5l0.6,0.6c0,0,0.1,0,0.1,0.1C37.9,7.3,38,7.6,38,7.8c0,0.2-0.1,0.4-0.2,0.6 c0,0-0.1,0.1-0.1,0.1L10.2,35.9c-0.1,0.2-0.2,0.3-0.5,0.4l-8.5,3.3c-0.1,0-0.1,0-0.2,0.1l0,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0 c-0.1,0-0.2,0-0.2,0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1c0,0,0-0.1-0.1-0.1 c-0.1-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0,0c0,0,0,0,0-0.1C0,39,0,39,0,38.9c0-0.1,0-0.2,0-0.2c0,0,0,0,0,0l0,0c0-0.1,0-0.1,0.1-0.2 L3.4,30c0.1-0.2,0.2-0.4,0.4-0.5l24-24c-0.2-0.7-0.9-1.2-1.7-1.2c-0.5,0-1,0.2-1.3,0.6l0,0L22,7.7l0,0l-5.9,5.9 c-0.3,0.3-0.9,0.3-1.2,0c-0.3-0.3-0.3-0.9,0-1.2l8.7-8.7c0,0,0,0,0,0c0.6-0.7,1.5-1.1,2.5-1.1c1.3,0,2.3,0.7,2.9,1.7l2.2-2.2 c0,0,0-0.1,0.1-0.1c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0,0,0.1,0.1,0.1,0.1l0.6,0.6l2.3-2.3c0,0,0-0.1,0.1-0.1 C35.8,0.1,36.1,0,36.3,0c0.2,0,0.4,0.1,0.6,0.2c0,0,0.1,0.1,0.1,0.1l2.4,2.4c0,0,0.1,0,0.1,0.1C39.7,3,39.7,3.2,39.7,3.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/Edit_Pencil.1fa8a8ba9e45c2c5a4f82d0d7646740c.svg";
export { ForwardRef as ReactComponent };